import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledHeaderGroup } = Styles;
export const HeaderGroup = ({ children, mobile, ...otherProps }) => {

    const childrenArray = React.Children.toArray(children);

    const visibleChildren = childrenArray.filter(child => (mobile ? child.props.mobile : true));

    return <StyledHeaderGroup {...otherProps}> {visibleChildren} </StyledHeaderGroup>;
};

HeaderGroup.propTypes = {
    children: PropTypes.node.isRequired,
    mobile: PropTypes.bool,
};

HeaderGroup.defaultProps = {
    mobile: false,
};

HeaderGroup.Styles = Styles;
